import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SopAssessmentPage from '@/components/sop-intake/sop-analyzer/SopAssessmentPage';
import { useClient } from '@/context/client-context';
import { useAuth } from '@/contexts/AuthContext';
import { getClient } from '@/components/clients/services/clients-api';
import type { Client } from '@/lib/types';

export default function SopNewPage() {
  const { client, setClient, isClientLoading } = useClient();
  const { user, loading: authLoading } = useAuth();
  const { id: clientId } = useParams<{ id: string }>();
  const [resolvedClient, setResolvedClient] = useState<Client | null>(client);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClient = async () => {
      if (!clientId || authLoading || !user) {
        setLoading(false);
        return;
      }

      if (client && client.id === clientId) {
        setResolvedClient(client);
        setLoading(false);
        return;
      }

      const fetchedClient = await getClient(clientId);
      if (fetchedClient) {
        setClient(fetchedClient);
        setResolvedClient(fetchedClient);
      }
      setLoading(false);
    };

    fetchClient();
  }, [client, clientId, authLoading, user, setClient]);

  if (isClientLoading || loading) {
    return (
      <div className="py-8 text-center text-muted-foreground">Loading client…</div>
    );
  }

  if (!resolvedClient) {
    return (
      <div className="py-8 text-center text-muted-foreground">Client could not be loaded.</div>
    );
  }

  return <SopAssessmentPage mode="new" />;
}
